import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";
import Tooltip from "@mui/material/Tooltip";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import "../projectGroupGrid.scss";
import { ReactComponent as Workspaces } from "assets/workspaces.svg";
import { Box } from "@mui/material";

const TooltipContent = ({ groupName, groupDescription }) => {
  return (
    <div className="projectGroup__tooltip--body">
      <div className="projectGroup__tooltip--title">{groupName || ""}</div>
      <p className="projectGroup__tooltip--description">
        {groupDescription || ""}
      </p>
    </div>
  );
};

function ProjectGroupItem({
  backgroundColor,
  projectGroup,
  isDefaultGroup,
  isDisplayUpdate,
  handleClickEdit,
  idHTML,
}) {
  const { t } = useTranslation();
  const [isHovering, setIsHovering] = useState(false);
  return (
    <div
      className="projectGroupListGrid__item"
      style={{ backgroundColor: "#EDF2FC" }}
      id={idHTML}
      onMouseEnter={() => {
        setIsHovering(true);
      }}
      onMouseLeave={() => {
        setIsHovering(false);
      }}
    >
      <div
        className="projectGroupListGrid__icon"
        style={{ display: "flex", alignItems: "center" }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Box
            sx={{
              width: "13px",
              marginRight: "10px",
              height: "13px",
              background: backgroundColor,
              borderRadius: "3px",
            }}
          />
          <NavLink
            className="projectGroupListGrid__item--title"
            to={`/projects?groupID=${projectGroup.id}`}
            style={{ width: isHovering ? "50%" : "87%" }}
          >
            {projectGroup?.name}
          </NavLink>
        </div>

        {/* <div className="projectGroupListGrid__icon--list">
          <label
            className="projectGroupListGrid_merge_view__icon--item"
            title={`${projectGroup?.number_project || 0} ${t(
              "DMH.VIEW.PGP.RIGHT.ALL.TASK"
            )}`}
          >
            <Workspaces className="ListItemIcon__icon" />
            <span className="projectGroupListGrid_merge_view__icon--number">
              {projectGroup?.number_children_group || 0}
            </span>
          </label>
          <label
            className="projectGroupListGrid__icon--item"
            title={`${projectGroup?.number_project || 0} ${t(
              "DMH.VIEW.PGP.RIGHT.ALL.TASK"
            )}`}
          >
            <ArticleOutlinedIcon />
            <span className="projectGroupListGrid__icon--number">
              {projectGroup?.number_project || 0}
            </span>
          </label>

          {isDefaultGroup && (
            <div className="projectGroupListGrid__icon--item">
              <FlagOutlinedIcon />
            </div>
          )}
        </div> */}

        <div
          className="projectGroupListGrid__icon--list "
          style={{
            position: "absolute",
            top: "50%",
            transform: "translateY(-50%)",
            right: "8px",
          }}
        >
          <Tooltip
            title={
              <TooltipContent
                groupName={projectGroup.name}
                groupDescription={projectGroup.description}
              />
            }
            arrow
            classes={{
              tooltip: "projectGroupListGrid__tooltip",
            }}
            placement="top"
          >
            <Box
              className="wp-wrapper-button"
              sx={{ background: "unset !important" }}
            >
              <InfoOutlinedIcon />
            </Box>
          </Tooltip>

          {isDisplayUpdate && (
            <Box
              onClick={handleClickEdit}
              className="wp-wrapper-button"
              sx={{ background: "unset !important" }}
            >
              <MoreVertOutlinedIcon />
            </Box>
          )}
        </div>
      </div>
    </div>
  );
}

export default ProjectGroupItem;
